import * as React from 'react';
const IconCheck2 = ({ color = '#89C900' }) => {
    return (React.createElement("svg", { width: 100, height: 100, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("rect", { width: 100, height: 100, rx: 50, fill: color, fillOpacity: 0.08 }),
        React.createElement("path", { d: "M50 76.667c14.667 0 26.667-12 26.667-26.667 0-14.667-12-26.667-26.666-26.667-14.667 0-26.667 12-26.667 26.667 0 14.667 12 26.667 26.667 26.667Z", stroke: color, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "m38.666 50 7.547 7.547 15.12-15.094", stroke: color, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
};
export default IconCheck2;
